export default __webpack_public_path__ + "static/media/UiUploadVid.aaaf5835.svg";